import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { notifyError } from '../utils/Notify';

const ProtectedRoute = ({ children }) => {
  const user = useSelector((state) => state.user);

  const isPikkopayEmail = user?.email?.toLowerCase().includes('pikkopay.fr');
  const hasAccess = user?._id && isPikkopayEmail;

  if (!hasAccess) {
    notifyError('Accès refusé');
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default ProtectedRoute;
